/* See https://community.algolia.com/shopify/hogan-helpers.html */

(function (algolia) {
    'use strict';

    var _ = algolia._;

    var formatPrice = function formatPrice(value) {
        return algolia.formatMoney(+value * 100);
    };


    var escapeHtml = function escapeHtml(unsafe) {
        return unsafe
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    }

    var productLoyaltyCheck = function productLoyaltyCheck(product) {
        let loyalty_discount_value = 10;
        var loyalty_percentage = (100 - loyalty_discount_value) / 100;

        //Ezt már nemnagyon használjuk sehol
        //var discount_ratio = 1.0 - product.price_ratio;

        product.show_loyalty_details = false;
        product.loyaltyprice = 0;
        product.have_loyalty_price_tag = false;
        product.have_introprice = false;
        product.product_on_sale = +product.compare_at_price && +product.compare_at_price > +product.price;
        product.denied_loyalty_discount = true;

        product.tags.forEach(function (product_tag) {
            if (0 <= product_tag.indexOf('loyaltyprice')) {
                product.have_loyalty_price_tag = true;
                product.loyaltyprice = product_tag.split("_")[1];
                product.original_price = product.price;
                product.denied_loyalty_discount = false;
            }

            if (0 <= product_tag.indexOf('OD')) {
                product.denied_loyalty_discount = false;
            }

            if (0 <= product_tag.indexOf('introprice')) {
                product.have_introprice = true;
                product.denied_loyalty_discount = false;
            }
        });

        if (!product.denied_loyalty_discount) {
            product.price = product.product_on_sale ? product.price : product.price * loyalty_percentage;
            product.show_loyalty_details = product.have_loyalty_price_tag;

            if(window.point_based_loyalty && product.have_loyalty_price_tag == false){
                product.show_loyalty_details = false;
            }
        }
    }

    algolia.helpers = {
        blogPermalink: function blogPermalink() {
            var res = this.permalink;

            return escapeHtml(res);
        },
        blogImage: function blogImage() {
            var res;
            if (this.images && this.images.thumbnail && this.images.thumbnail.url) {
                res = `<img src="${this.images.thumbnail.url}" alt="${this.post_title}">`;
            } else {
                res = '';
            }

            return res;
        },
        blogTitle: function blogTitle() {
            var res = this.post_title;

            return escapeHtml(res);
        },
        blogCategory: function blogCategory() {
            var res;

            if (this.taxonomies.category && Object.keys(this.taxonomies.category).length > 0) {
                res = this.taxonomies.category[0];
            } else {
                res = '';
            }

            return escapeHtml(res);
        },
        formatNumber: function formatNumber(text, render) {
            return Number(render(text)).toLocaleString();
        },
        formattedPrice: function formattedPrice(text, render) {
            return formatPrice(render(text));
        },
        formattedPriceWithoutDecimals: function formattedPriceWithoutDecimals(text, render) {
            return formatPrice(render(text)).replace(/\.\d+$/, '');
        },
        formattedPriceWithComparison: function formattedPriceWithComparison() {

            productLoyaltyCheck(this);

            if (this.product_on_sale && false == this.show_loyalty_details) {
                var res = '<div class="product-on-sale">' +
                    '<span class="price" >' + formatPrice(this.price) + '</span>';
                res += ' <span class="price-before"><span>' + formatPrice(this.compare_at_price) + '</span></span> ';
                res += ' </div> ';
                //        res += ' <span class="ais-hit--price-discount" style="font-weight: ' + (Math.floor(discount_ratio * 10) * 100) + ';">-' + Math.floor(discount_ratio * 100) + '%</span>';

            } else {
                if (true == this.show_loyalty_details) {
                    var res = '<div class="product-on-sale">' +
                        '<span class="price" >' + formatPrice(this.loyaltyprice) + '</span>';
                    res += ' <span class="price-before"><span>' + formatPrice(this.original_price) + '</span></span> ';
                    res += ' </div> ';
                } else {
                    var res = '<span class="ais-hit--price" >' + formatPrice(this.price) + '</span>';
                }
            }

            return res;
        },

        formattedPriceWithComparisonInstant: function formattedPriceWithComparison() {

            productLoyaltyCheck(this);

            if (this.product_on_sale && false == this.show_loyalty_details) {
                var res = '<div class="product-on-sale">' +
                    '<span class="price" >' + formatPrice(this.price) + '</span>';
                res += ' <span class="price-before"><span>' + formatPrice(this.compare_at_price) + '</span></span> ';
                res += ' </div> ';

            } else {
                if (true == this.show_loyalty_details) {
                    var res = '<div class="product-on-sale">' +
                        '<span class="price" >' + formatPrice(this.loyaltyprice) + '</span>';
                    res += ' <span class="price-before"><span>' + formatPrice(this.original_price) + '</span></span> ';
                    res += ' </div> ';
                } else {
                    var res = '<span class="full price" >' + formatPrice(this.price) + '</span>';
                }
            }

            return res;
        },
        fullTitle: function fullTitle() {
            var res = this.title;
            if (this.variant_title && this.variant_title !== 'Default Title' && this.variant_title !== 'Default') {
                res += ' (' + this.variant_title + ')';
            }

            return escapeHtml(res);
        },
        fullHTMLTitle: function fullHTMLTitle() {
            var res = this._highlightResult.title.value;
            // if (this.variant_title && this.variant_title !== 'Default Title' && this.variant_title !== 'Default') {
            //    res += ' <br><span class="algolia-variant">(' + this._highlightResult.variant_title.value + ')</span>';
            //  }

            return res;
        },
        floor: function floor(text, render) {
            return '' + Math.floor(+render(text));
        },
        ceil: function ceil(text, render) {
            return '' + Math.ceil(+render(text));
        },
        sizedImage: function sizedImage(text, render) {
            if (!this.image) {
                return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
            }
            var size = render(text).replace(/^\s+|\s+$/g, ''); // Render and trim
            if (size === 'original') {
                return this.image;
            }
            return this.image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
        },

        addLabels: function () {
            var res = "";

            if (this.tags.includes('Új termék')) {
                // TODO: magyarba is
                res += '<span class="aa-new-product">New</span>';
            }
            if (this.tags.includes('Új íz')) {
                // TODO: magyarba is
                res += '<span class="aa-new-product">New</span><span class="aa-new-taste">Flavor </span> ';
            }

            if (this.product_on_sale && false == this.show_loyalty_details) {
                // TODO: magyarba is
                res += '<span class="aa-on-sale">On Sale</span>';
            }

            if ((this.have_loyalty_price_tag && this.show_loyalty_details == true) || (this.have_loyalty_price_tag && false == this.product_on_sale)) {
                if (this.have_introprice) {
                    res += '<span class="aa-on-sale">Introductory price</span>';
                } else {
                    res += '<span class="aa-on-sale">Loyalty promotion</span>';
                }
            }

            return res;
        },

        unitPrice: function () {
            let unitPrice = '';
            const gVolumeThreshold = 251;
            const mlVolumeThreshold = 251;

            
                const unitPriceMeta = this.meta.unit_price;

                if (unitPriceMeta && unitPriceMeta.unit && unitPriceMeta.volume) {
                    let priceToUse = Number(this.price);
                    let unitPriceValue = 1.0 / unitPriceMeta.volume * priceToUse;
                    let unitToRender = unitPriceMeta.unit;

                    if ("g" === unitPriceMeta.unit) {
                        let shouldUseKg = true;
                        let volumeBelowThreshold = false;

                        if (unitPriceMeta.volume < gVolumeThreshold) {
                            volumeBelowThreshold = true;
                        }

                        if (volumeBelowThreshold && false) {
                            shouldUseKg = false;
                            unitPriceValue = unitPriceValue * 100;
                            unitToRender = "100g";
                        }

                        if (shouldUseKg) {
                            unitPriceValue = unitPriceValue * 1000;
                            unitToRender = "kg";
                        }
                    }

                    if("ml" === unitPriceMeta.unit) {
                        let shouldUseL = true;
                        let volumeBelowThreshold = false;

                        if (unitPriceMeta.volume < mlVolumeThreshold) {
                            volumeBelowThreshold = true;
                        }

                        if (volumeBelowThreshold && false) {
                            shouldUseL = false;
                            unitPriceValue = unitPriceValue * 100;
                            unitToRender = "100ml";
                        }

                        if (shouldUseL) {
                            unitPriceValue = unitPriceValue * 1000;
                            unitToRender = "l";
                        }
                    }

                    unitPrice = Shopify.formatMoney(unitPriceValue * 100) + '/' + unitToRender
                }
            

            return unitPrice;
        },
    };

    _.forEach(['pico', 'icon', 'thumb', 'small', 'compact', 'medium', 'large', 'grande', 'original'], function (size) {
        algolia.helpers[size + 'Image'] = (function (_size) {
            return function () {
                if (!this.image) {
                    return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
                }
                if (_size === 'original') {
                    return this.image;
                }
                return this.image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + _size + '.$2');
            };
        })(size); // We need to create a new scope so that the internal size has the good value.
    });

    /* Create an Hogan lambda, which doesn't respect the mustache doc */
    algolia.hoganHelpers = _.reduce(algolia.helpers, function (res, helper, name) {
        res[name] = function () {
            return function (text) {
                var render = function (value) {
                    return Hogan.compile(value, algolia.hoganOptions).render(this);
                }.bind(this);
                return helper.call(this, text, render);
            }.bind(this);
        };
        return res;
    }, {});
}(algoliaShopify));
